import cloneDeep from 'lodash/cloneDeep'
import initialState from './state.js'

export default {
  RESET_CLUBE_MODULE(state) {
    const initial = cloneDeep(initialState)
    delete initial['inicioFidelidade']
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key]
    })
  },
}
